import {
  TabComponent,
  TabItemDirective,
  TabItemsDirective,
} from '@syncfusion/ej2-react-navigations';
import * as React from 'react';
import OrderAttachments from '../CloudPlaner/OrderAttachments';
import Material from '../CloudPlaner/Material';
import WorkOrders from '../CloudPlaner/WorkOrders';
import Operations from '../CloudPlaner/Operations';
import ScheduledComponent, {CloudScheduler} from './CloudScheduler';
import OperationResourcesSchedulerList from './OperationResourcesSchedulerList';
import { connect } from 'react-redux';
import {RootState, store} from '../../store';
import PlanningConsole from '../CloudPlaner/PlanningConsole';
import {DropDownListComponent, MultiSelectComponent} from "@syncfusion/ej2-react-dropdowns";
import {ButtonComponent} from "@syncfusion/ej2-react-buttons";
import {
  setCloudSchedulerFilterTeamDropdownValueChanged,
  setCloudSchedularGantDataChanged,
  setIsDataPulled,
  setIsPlanSelected
} from "../../redux/search.slice";
import Message from "../../utils/Message/Message";
import moment from "moment-timezone";
import {loadingShow} from "../../App";
import {getPlan} from "../../services/ControlCenter/PlanServices";
import {getEvents} from "../../services/events/event";
import GlobalDialog from "../../components/GlobalDialog";
import {GlobalMultiSelection} from "../../components/GlobalDropDown";
import {ButtonPropsModel} from "@syncfusion/ej2-react-popups";
import Load from "./Load";
import {FaAngleDown, FaAngleUp} from "react-icons/fa";
import { useDispatch} from 'react-redux';
import {ThemeContext} from "../../context/theme.context";
import {AiOutlineFilter} from "react-icons/ai";
interface IProps {
  searchCaseOperation: string;
  searchCaseOrder: string;
  searchCaseGantt: string;
  dispatch?: any;
  setCloudSchedularGantDataChanged: (value: boolean) => void;
  isDataPulled: boolean;
  setIsDataPulled: (value: boolean) => void;
}
interface IState {
  planData: Array<any>;
  queryForLoad: string;
  eventsData: any;
  GantData: [],
  loadGant: [],
  hideGant: boolean;
  query: string;
  projectStartDate: Date;
  projectEndDate: Date;
  hideFilterDialog: boolean;
  teamIds: Array<number>;
  currentIcon: any;
  expandableButton: boolean;
  status: boolean;
  allowRender: boolean;
  schedulerFetchRequest: boolean;
  expandStatus: boolean;
  filterLoad: boolean;
}
class SchedulerTabBar extends React.Component<IProps, IState> {
  static contextType = ThemeContext;
  context!: React.ContextType<typeof ThemeContext>;
  public queryForLoad: string = '';
  private fieldEvent: object = {
    text: 'eventCode',
    value: 'eventId',
  };
  private fieldPlan: object = {
    text: 'plan_name',
    value: 'ID',
  };
  private headerText: any;
  private tabObj: any;
  private readonly server_gmt: number | null = null;
  private isInitial = true;
  private current_plan_id: number = -1;
  private cur_plan_start_date: Date = new Date();
  private cur_plan_end_date: Date = new Date();
  private current_plan_data: any = [];
  private eventDropDown: DropDownListComponent = new DropDownListComponent({});
  private planDropDown: DropDownListComponent = new DropDownListComponent({});
  public static start_date: Date =
      localStorage.getItem('load_start_date') !== null
          ? new Date(localStorage.getItem('load_start_date') as string)
          : new Date();
  public static isDateChangeRequest: boolean = false;
  private tradeQuery = 'trade';
  private teamQuery = 'team';
  private shiftQuery = 'shift';
  public static tradeExchangeText = '';
  public static tradeExchangeIds = '';
  public static teamExchangeText = '';
  public static teamExchangeIds = '';
  private tradesLocalVal = localStorage.getItem('trades');
  private tradesLocalText = localStorage.getItem('trades_text');
  private tradeValues: Array<any> =
      this.tradesLocalVal === null
          ? []
          : [...this.tradesLocalVal.split(',').map((el) => Number(el))];

  private tradeTexts: Array<any> =
      this.tradesLocalText === null
          ? []
          : [...this.tradesLocalText.split(',').map((el) => el)];
  private teamsLocalVal = localStorage.getItem('teams');
  private teamsLocalText = localStorage.getItem('teams_text');
  private teamValues: Array<any> =
      this.teamsLocalVal === null
          ? []
          : [...this.teamsLocalVal.split(',').map((el) => Number(el))];
  private teamTexts: Array<any> =
      this.teamsLocalText === null
          ? []
          : [...this.teamsLocalText.split(',').map((el) => el)];
  private shiftsLocalVal = localStorage.getItem('shifts');
  private shiftsLocalText = localStorage.getItem('shifts_text');
  private shiftValues: Array<any> =
      this.shiftsLocalVal === null
          ? []
          : [...this.shiftsLocalVal.split(',').map((el) => el)];
  private shiftTexts: Array<any> =
      this.shiftsLocalText === null
          ? []
          : [...this.shiftsLocalText.split(',').map((el) => el)];
  private teamFMSCom: MultiSelectComponent = new MultiSelectComponent({});
  private shiftFMSCom: MultiSelectComponent = new MultiSelectComponent({});
  private tradeFMSCom: MultiSelectComponent = new MultiSelectComponent({});
  private dateRangeValue: Date[] = [
    new Date(),
    new Date(new Date().setDate(new Date().getDate() + 21)),
  ];
  private isMountedCS: boolean = false;
  constructor(props: IProps) {
    super(props);
    const state = store.getState();
    this.server_gmt = state.search.server_gmt;
    this.props.dispatch(setCloudSchedularGantDataChanged(true));
    this.queryForLoad = `'8/1/2022 ${this.server_gmt}:00:00'$'8/31/2022 ${this.server_gmt}:00:00'$''${localStorage.getItem('cs_event_dd_value')}''$'${this.server_gmt}:00:00'$trade$''$''`;
    this.state = {
      queryForLoad: '',
      planData: [],
      eventsData: [],
      GantData: [],
      loadGant: [],
      hideGant: false,
      query: '',
      projectStartDate: new Date(
          new Date().getFullYear(),
          new Date().getMonth(),
          1
      ),
      projectEndDate: new Date(
          new Date().getFullYear(),
          new Date().getMonth() + 1,
          0
      ),
      hideFilterDialog: false,
      teamIds: [],
      currentIcon: <FaAngleDown size='12px'/>,
      expandableButton: false,
      status: false,
      allowRender: false,
      schedulerFetchRequest: false,
      expandStatus: false,
      filterLoad : (this.teamTexts.length > 0 ||  this.tradeTexts.length > 0 ||  this.shiftTexts.length > 0)? true : false,
    }
    this.headerText = [
      { text: 'Gantt' },
      { text: 'Work Orders' },
      { text: 'Operations' },
      { text: 'Resource Planning' },
      { text: 'Assignments' },
    ];
  }
  private buttonFilter: ButtonPropsModel[] = [
    {
      click: () => {
        this.applyFilter();
      },
      buttonModel: {
        content: 'Apply',
        isPrimary: true,
      },
    },
    {
      click: () => {
        this.setState({hideFilterDialog: false});
      },
      buttonModel: {
        content: 'Cancel',
        isPrimary: false,
      },
    },
  ];
  formatDate(isoDate: string) {
    const cleanedDateStr = isoDate.replace(/^"|"$/g, '');
    const date = cleanedDateStr && new Date(cleanedDateStr);

    if (date instanceof Date) {
      const timeZoneDiff = this.server_gmt;
      let thePlanID = Number(localStorage.getItem('cs_plan_dd_value'));
      const month = date.getUTCMonth() + 1;
      const day = date.getUTCDate();
      const year = date.getUTCFullYear();
      if (thePlanID != -1) {
        this.setState({
          queryForLoad: `'${year}/${month}/${day} ${timeZoneDiff}:00:00'$'${year}/${month + 1
          }/${day} ${timeZoneDiff}:00:00'$${thePlanID}$'${timeZoneDiff}:00:00'$trade$''$''`,
        });
      }
    }
  }
  async componentDidMount() {
    this.isMountedCS = true;
    const { setExpandStatus } = this.context;
    setExpandStatus(false);
    this.props.setIsDataPulled(false);
    // this.tabObj.element.classList.add('e-fill');
    let cloudSchedularLastFilteredDate = localStorage.getItem(
        'CloudSchedularLastFilteredDate'
    );

    cloudSchedularLastFilteredDate &&
    this.formatDate(cloudSchedularLastFilteredDate);

    let theEventID = Number(localStorage.getItem('cs_event_dd_value'));
    let thePlanID = Number(localStorage.getItem('cs_plan_dd_value'));
    let plan = await this.getEvent();
    this.current_plan_data = plan
    await this.getPlan(theEventID);
    if (theEventID !== 0 && thePlanID !== 0) {
      if (this.eventDropDown) this.eventDropDown.value = theEventID;
      this.onChangeEventPlan(false, {
        value: theEventID,
        plan_id: thePlanID,
        isTheSavedPlan: true,
      });
    } else {
      this.props.dispatch(
          setIsPlanSelected({
            isOrderPlanSelected: true,
            isOpPlanSelected: true,
            planId: 0,
          })
      );
    }
  }

  componentDidUpdate(
    prevProps: Readonly<IProps>,
    prevState: Readonly<IState>,
    snapshot?: any
  ): void {
    if (prevProps.searchCaseOrder !== this.props.searchCaseOrder) {
      this.tabObj.selectedItem = 1;
    }
    if (prevProps.searchCaseOperation !== this.props.searchCaseOperation) {
      this.tabObj.selectedItem = 2;
    }

    if (prevProps.searchCaseGantt !== this.props.searchCaseGantt) {
      this.tabObj.selectedItem = 3;
    }
  }

    async getEvent() {
    await getEvents().then((result) => {

      const incomingData = Array.isArray(result?.data) ? result.data : [];

      incomingData.unshift({
        eventCode: '',
        eventId: -1,
      });

      if (this.isMountedCS) {
        this.setState({
          eventsData: incomingData,
        });
      }
    }).catch(error => {
      if (this.isMountedCS) {
        this.setState({ eventsData: [] });
      }
    });
  }
  async getPlan(event_id: Number) {
    await getPlan(event_id)
      .then((res) => {
        const incomingData = Array.isArray(res?.data) ? res.data : [];
        incomingData.unshift({
          plan_name: '',
          ID: -1,
        });

        if (this.isMountedCS) {
          this.setState({ planData: incomingData });
        }
      }).catch(error => {
        if (this.isMountedCS) {
          this.setState({ planData: [] });
        }
      });
  }
  async onChangeEventPlan(isFirst: boolean, args: any) {
    localStorage.setItem('cs_event_dd_value', args.value);
    this.isInitial = true;
    const eventId = args.value;
    await this.getPlan(eventId);
    const plan_id =
        this.state.planData.length > 0 ? this.state.planData[1]?.ID : null;
    if (eventId === -1) {
      this.setState({
        GantData: [],
        hideGant: false,
        loadGant: [],
        planData: [],
      });
      //this.gantObj.dataSource = [];
      this.props.dispatch(
          setIsPlanSelected({
            isOrderPlanSelected: true,
            isOpPlanSelected: true,
            planId: 0,
          })
      );
      this.current_plan_id = -1;
      localStorage.removeItem('cs_event_dd_value');
      localStorage.removeItem('cs_plan_dd_value');
      return;
    }
    if (this.state.planData.length === 2 || args.isTheSavedPlan) {
      let thePlan = this.state.planData[1];
      if (args.isTheSavedPlan) {
        this.planDropDown && (this.planDropDown.value = args.plan_id);
        if (this.state.planData.length === 1) {
          return;
        } else {
          // this.onChangePlan(isFirst, { value: args.plan_id });
        }
        return;
      }
      if (plan_id !== null) {
        localStorage.setItem('cs_plan_dd_value', plan_id);
        this.planDropDown && (this.planDropDown.value = plan_id);
        this.current_plan_data = thePlan;
        this.cur_plan_start_date = thePlan.planned_start_date;
        this.cur_plan_end_date = thePlan.planned_end_date;
        // this.setState({
        //   current_plan_isLocked: thePlan.isLocked,
        // });
        this.current_plan_id = thePlan.ID;
        this.props.dispatch(
            setIsPlanSelected({
              isOrderPlanSelected: true,
              isOpPlanSelected: true,
              planId: thePlan.ID,
            })
        );
        // this.buildQuery();
        var startDate = moment(
            new Date(this.cur_plan_start_date).setDate(
                new Date(this.cur_plan_start_date).getDate() - 7
            )
        ).format('yyy-MM-DD');
        var endDate = moment(
            new Date(this.cur_plan_start_date).setDate(
                new Date(this.cur_plan_start_date).getDate() + 14
            )
        ).format('yyy-MM-DD');
        this.setInitialParamters(startDate, endDate);
        // CloudScheduler.start_date = thePlan.planned_start_date;
        SchedulerTabBar.isDateChangeRequest = true;
        this.context.setPlanId(this.current_plan_id);
        this.context.setLoadAllowChange(true);
        if (isFirst) {
          this.context.setResourcesAllowChange(true);
        }
      }
    } else {
      this.setState({
        GantData: [],
        hideGant: false,
        loadGant: [],
      });
      //this.gantObj.dataSource = [];
      this.props.dispatch(
          setIsPlanSelected({
            isOrderPlanSelected: true,
            isOpPlanSelected: true,
            planId: 0,
          })
      );
      loadingShow(false);
    }
    loadingShow(false);
  }
  async onChangePlan(isFirst: boolean, args: any) {
    //loadingShow(true);
    this.isInitial = true;
    this.current_plan_id = args.value;
    localStorage.setItem('cs_plan_dd_value', args.value);
    if (-1 === args.value) {
      this.setState({
        GantData: [],
        hideGant: false,
      });
      this.props.dispatch(
          setIsPlanSelected({
            isOrderPlanSelected: true,
            isOpPlanSelected: true,
            planId: 0,
          })
      );
      //this.gantObj.dataSource = [];
      localStorage.removeItem('cs_plan_dd_value');
    } else {
      var theElement = this.state.planData.filter((el) => {
        return el.ID === args.value;
      });
      this.current_plan_data = theElement[0];
      this.cur_plan_start_date = theElement[0]?.planned_start_date;
      this.cur_plan_end_date = theElement[0]?.planned_end_date;
      var startDate = moment(
          new Date(SchedulerTabBar.start_date).setDate(
              new Date(SchedulerTabBar.start_date).getDate()
          )
      ).format('yyy-MM-DD');
      var endDate = moment(
          new Date(
              new Date(SchedulerTabBar.start_date).setDate(
                  SchedulerTabBar.start_date.getDate() + 3 * 7
              )
          )
      ).format('yyy-MM-DD');
      let gmtValue = this.server_gmt ? this.server_gmt : 10;
      this.setState({
        projectStartDate: new Date(new Date(startDate).getTime() + 0 * 60 * 60 * 1000),
        projectEndDate: new Date(new Date(endDate).getTime() + 0 * 60 * 60 * 1000),

      });
      this.props.dispatch(
          setIsPlanSelected({
            isOrderPlanSelected: true,
            isOpPlanSelected: true,
            planId: args.value,
          })
      );
      this.setInitialParamters(startDate, endDate);
      SchedulerTabBar.isDateChangeRequest = true;
      this.context.setLoadAllowChange(true);
      this.context.setPlanId(this.current_plan_id);
      if (isFirst) {
        this.context.setResourcesAllowChange(true);
      }
    }
    const teams = localStorage.getItem('teams') ? localStorage.getItem('teams') : '';
    const trades = localStorage.getItem('trades') ? localStorage.getItem('trades') : 'trade';
    const shifts = localStorage.getItem('shifts') ? localStorage.getItem('shifts_text') :'';
    var timeZoneDiff = this.server_gmt;

    var startDate = moment(
        new Date(SchedulerTabBar.start_date).setDate(
            new Date(SchedulerTabBar.start_date).getDate()
        )
    ).format('yyy-MM-DD');
    var endDate = moment(
        new Date(
            new Date(SchedulerTabBar.start_date).setDate(
                SchedulerTabBar.start_date.getDate() + 3 * 7
            )
        )
    ).format('yyy-MM-DD');
    this.setState({ queryForLoad: `'${startDate} ${timeZoneDiff}:00:00'$'${endDate} ${timeZoneDiff}:00:00'$${this.current_plan_id}$'${timeZoneDiff}:00:00'$'${trades}'$'${teams}'$'${shifts}'`});
    loadingShow(false);
  }

  handleOfLoadGridDateChange = (args: Date, weekCount: number) => {
    if (this.current_plan_id === -1) {
      return;
    }
    loadingShow(true, 'Loading...');
      let trades =  localStorage.getItem('trades');
      let teams =  localStorage.getItem('teams');
      let shifts =  localStorage.getItem('shifts');

      var theValuesIds = trades ? trades : 'trade' ;
      var theTeamValuesIds = teams ? teams : '';
      var theShiftValuesIds = shifts ? shifts : '';

      this.tradeQuery = `'${theValuesIds?.toString()}'`;
      this.teamQuery = `'${theTeamValuesIds?.toString()}'`;
      this.shiftQuery = `'${theShiftValuesIds?.toString()}'`;

    var timeZoneDiff = this.server_gmt;
    this.dateRangeValue[0] = new Date(new Date(args).setDate(args.getDate()));
    this.dateRangeValue[1] = new Date(
        new Date(args).setDate(args.getDate() + weekCount * 7)
    );
    var startDate = moment(new Date(args).setDate(args.getDate())).format(
        'yyy-MM-DD'
    );
    var endDate = moment(
        new Date(args).setDate(args.getDate() + weekCount * 7)
    ).format('yyy-MM-DD');
    var resultLoad = `'${startDate} ${timeZoneDiff}:00:00'$'${endDate} ${timeZoneDiff}:00:00'$${this.current_plan_id}$'${timeZoneDiff}:00:00'$${this.tradeQuery}$${this.teamQuery}$${this.shiftQuery}`;
    this.queryForLoad = resultLoad;
    SchedulerTabBar.start_date = moment(startDate).toDate();
    this.context.setLoadAllowChange(true);
    let gmtValue = this.server_gmt ? this.server_gmt : 10;
    this.setState({
      query: this.queryForLoad,
      queryForLoad: resultLoad,
      projectStartDate: moment.utc(startDate).add(10).toDate(),
      projectEndDate:moment(endDate).toDate(),

    });
  };
  setInitialParamters(startDate: string, endDate: string) {
    let theValuesIds;
    if (this.teamTexts.length > 0 && this.teamValues.length > 0) {
      let theTempValue = '';
      this.teamTexts.map((el, index: number) => {
        theTempValue += `''${el}''`;
        if (index !== this.teamTexts.length - 1) {
          theTempValue += ',';
        }
      });
      theTempValue = `'${theTempValue}'`;
      theValuesIds = this.teamValues;
      SchedulerTabBar.teamExchangeText = theTempValue;
      SchedulerTabBar.teamExchangeIds = `'${theValuesIds?.toString()}'`;
      this.teamQuery = `'${theValuesIds?.toString()}'`;
    } else {
      this.teamQuery = 'team';
      SchedulerTabBar.teamExchangeText = '';
      SchedulerTabBar.teamExchangeIds = '';
    }
    if (this.tradeTexts.length > 0 && this.tradeValues.length > 0) {
      let theTempValue = '';
      this.tradeTexts.map((el, index: number) => {
        theTempValue += `''${el}''`;
        if (index !== this.tradeTexts.length - 1) {
          theTempValue += ',';
        }
      });
      theTempValue = `'${theTempValue}'`;
      theValuesIds = this.tradeValues;
      SchedulerTabBar.tradeExchangeText = theTempValue;
      SchedulerTabBar.tradeExchangeIds = `'${theValuesIds?.toString()}'`;
      this.tradeQuery = `'${theValuesIds?.toString()}'`;
    } else {
      this.tradeQuery = 'trade';
      SchedulerTabBar.tradeExchangeText = '';
      SchedulerTabBar.tradeExchangeIds = '';
    }
    if (this.shiftTexts.length > 0 && this.shiftValues.length > 0) {
      let theTempValue = '';
      this.shiftTexts.map((el, index: number) => {
        theTempValue += `''${el}''`;
        if (index !== this.shiftTexts.length - 1) {
          theTempValue += ',';
        }
      });
      theTempValue = `'${theTempValue}'`;
      theValuesIds = this.shiftValues;
      this.shiftQuery = `'${theValuesIds?.toString()}'`;
    } else {
      this.shiftQuery = '';
    }


    const timeZoneDiff = this.server_gmt;
    let end = new Date(
        new Date(startDate).setDate(new Date(startDate).getDate() + 21)
    );
    let resultKPIQuery = `'${startDate} ${timeZoneDiff}:00:00'$'${moment(
        end
    ).format('yyy-MM-DD')} ${timeZoneDiff}:00:00'$${this.current_plan_id
    }$'${timeZoneDiff}:00:00'$${this.tradeQuery}`;
    let resultLoad = `'${startDate} ${timeZoneDiff}:00:00'$'${moment(end).format(
        'yyy-MM-DD'
    )} ${timeZoneDiff}:00:00'$${this.current_plan_id}$'${timeZoneDiff}:00:00'$${this.tradeQuery
    }$${this.teamQuery}$${this.shiftQuery}`;
    this.queryForLoad = resultLoad;
  }

  applyFilter() {
    if (this.current_plan_id === -1) {
      Message.error('Please select event and plan before applying filter');
      return;
    }
    const trades = (this.tradeFMSCom?.value?.length ?? 0) > 0
        ? this.tradeFMSCom!.value!.toString()
        : 'trade';
    let teams = this.teamFMSCom?.value ? this.teamFMSCom.value.toString() : '';
    let shifts = this.shiftFMSCom?.value ? this.shiftFMSCom.value.toString() : '';

    let tradesText = this.tradeFMSCom?.text ? this.tradeFMSCom.text.toString() : '';
    let teamsText = this.teamFMSCom?.text ? this.teamFMSCom.text.toString() : '';
    let shiftsText = this.shiftFMSCom?.text ? this.shiftFMSCom.text.toString() : '';
    if (
        this.tradeFMSCom?.value?.toString() &&
        this.tradeFMSCom?.text?.toString()
    ) {
      localStorage.setItem('trades', trades);
      localStorage.setItem('trades_text', tradesText);
    }
      if (
          this.teamFMSCom.value?.toString() &&
          this.teamFMSCom?.text?.toString()
      ) {
        localStorage.setItem('teams', teams);
        localStorage.setItem('teams_text', teamsText);
      }
      if (
          this.shiftFMSCom?.value?.toString() &&
          this.shiftFMSCom?.text?.toString()
      ) {
        localStorage.setItem('shifts', shifts);
        localStorage.setItem('shifts_text', shiftsText);
      }

      var theValuesIds = trades;
      var theTeamValuesIds = teams;
      var theShiftValuesIds = shifts;
      this.tradeQuery = `'${theValuesIds}'`;
      this.teamQuery = `'${theTeamValuesIds}'`;
      this.shiftQuery = `'${theShiftValuesIds}'`;

    const timeZoneDiff = this.server_gmt;
    let startDate = moment(this.dateRangeValue[0]).format('yyy-MM-DD');
    let endDate = moment(this.dateRangeValue[1]).format('yyy-MM-DD');
    SchedulerTabBar.start_date = new Date(startDate);
    let resultLoad = `'${startDate} ${timeZoneDiff}:00:00'$'${endDate} ${timeZoneDiff}:00:00'$${this.current_plan_id}$'${timeZoneDiff}:00:00'$${this.tradeQuery}$${this.teamQuery}$${this.shiftQuery}`;
    this.queryForLoad = resultLoad;

    this.setState({
      query: this.queryForLoad,
      queryForLoad: resultLoad,
    });
    this.context.setLoadAllowChange(true);
    this.setState({hideFilterDialog: false});
    this.setState({filterLoad:((teamsText !== ''||  tradesText !== '')||  shiftsText !== '') ? true : false})
  }
  expand = () => {
    let element = document.getElementById('expandable');
    if (this.state.status) {
      element?.classList.remove('layoutExpand');
      element?.classList.add('layoutCollapse');
    } else {
      element?.classList.remove('layoutCollapse');
      element?.classList.add('layoutExpand');
    }
    const { setExpandStatus } = this.context;
    setExpandStatus(!this.state.status);
    this.setState({
      expandStatus:!this.state.status,
      status: !this.state.status,
      currentIcon: this.state.status ? (
          <FaAngleDown size='14px'/>
      ) : (
          <FaAngleUp size='14px'/>
      ),
      allowRender: true,
    });
  };
  content0 = () => {
    return <ScheduledComponent current_plan_id={1026} schedulerFetchRequest = {this.state.schedulerFetchRequest} expandStatus = {this.state.expandStatus}/>;
  }
  renderScheduledComponent = () => {
    return (
        <ScheduledComponent
            current_plan_id={1026}
            schedulerFetchRequest={this.state.schedulerFetchRequest}
        />
    );
  };
  content1() {
    return <WorkOrders needDidMount={true} needExpandStatus={true}/>;
  }
  content2() {
    return <Operations needDidMount={false} needExpandStatus={true}/>;
  }
  content3() {
    return <PlanningConsole needExpandStatus={true}/>;
  }
  content4() {
    return <OperationResourcesSchedulerList />;
  }

  contentMaterial() {
    return <Material />;
  }
  contentAttachment() {
    return <OrderAttachments isSchedulerSide={true} />;
  }
  componentWillUnmount() {
    this.isMountedCS = false;
    if (this.context?.setPlanId) {
      this.context.setPlanId(0);
    }
  }
  begin(args: any) {
    if (args.isSwiped) {
      args.cancel = true;
    }
  }

  ganntFItHandler(date: Date) {
    var startDate = moment(
        new Date(this.cur_plan_start_date).setDate(
            new Date(this.cur_plan_start_date).getDate() - 7
        )
    ).format('yyy-MM-DD');
    var endDate = moment(
        new Date(this.cur_plan_start_date).setDate(
            new Date(this.cur_plan_start_date).getDate() + 14
        )
    ).format('yyy-MM-DD');
    this.setInitialParamters(startDate, endDate);
  }
  render() {
    return (
      <div>
        <div style={{ display: "flex", gap: "10px"  ,justifyContent: "flex-end"}}>
          <div>
            {this.props.isDataPulled && (
                <AiOutlineFilter
                    size={30}
                    style={{
                      marginRight: 5,
                      color: this.state.filterLoad ? "#61dafb" : undefined
                    }}
                    onClick={() => {
                      if (this.props.isDataPulled) {
                        this.setState({hideFilterDialog: true});
                      } else {
                        Message.info(
                            'Please get selected Event-Plan`s data for filter'
                        );
                      }
                    }}
                />
            )}

          </div>
          <div className='cloud-scheduler-input'>
            <DropDownListComponent
                placeholder='Event'
                ref={(el: DropDownListComponent) => (this.eventDropDown = el)}
                style={{ height: 25 }}
                dataSource={this.state.eventsData}
                fields={this.fieldEvent}
                value={0}
                onChange={this.onChangeEventPlan.bind(this, true)}
            />
          </div>
          <div className='cloud-scheduler-input'>
            <DropDownListComponent
                ref={(el: DropDownListComponent) => (this.planDropDown = el)}
                placeholder='Plan'
                style={{ height: 25 }}
                dataSource={this.state.planData}
                fields={this.fieldPlan}
                onChange={this.onChangePlan.bind(this, true)}
            />
          </div>
          <ButtonComponent
              style={{ fontSize: '12px' }}
              onClick={() => {
                let planId = localStorage.getItem('cs_plan_dd_value');
                if (planId && Number(planId) > 0) {
                  this.context.setSchedulerFetchRequest(true);
                  this.context.setPlanId(true);
                  this.onChangePlan(true, { value: planId });
                  this.props.dispatch(setIsDataPulled(true));
                } else {
                  Message.error('Select a plan...');
                }
              }}
              content='Apply'
          />
        </div>
        <div className='main' onClick={this.expand.bind(this)}>
          <button
              className='expandableButton'
              disabled={this.state.expandableButton}
          >
            {this.state.currentIcon}
          </button>
        </div>

        <div id='expandable' className='layout' style={{ display: "flex", flexDirection: "column", gap: "10px" ,width: "100%", marginBottom:"18px" }}>

          <div style={{ display: "flex", gap: "10px" , width: "100%", maxHeight:"30vh"}}>
            <Load
                setCloudSchedularGantDataChanged={this.props.setCloudSchedularGantDataChanged.bind(this)}
                isLoad={false}
                queryForLoad={this.state.queryForLoad}
                handleDatePickerChange={this.handleOfLoadGridDateChange.bind(this)}
                fitInGant={this.ganntFItHandler.bind(this)}
                refreshToken={''}
            />
          </div>
        </div>
        {this.state.hideFilterDialog ? (
            <GlobalDialog
                showDialog={this.state.hideFilterDialog}
                setShowDialog={(val) => this.setState({hideFilterDialog: val})}
                header='Apply Filter'
                width={'500px'}
                hideDoneButton={true}
                buttons={this.buttonFilter}
            >
              <div style={{margin: '10px'}}>
                <GlobalMultiSelection
                    floatLabelType='Always'
                    field={{text: 'team_code', value: 'team_id'}}
                    id='cloudscheduler-multiselection-team'
                    url='team'
                    placeHolder='Select Teams'
                    value={this.teamValues}
                    onChange={(val: any) => {
                      this.teamValues = val.target.value;
                      this.setState({teamIds: this.teamValues});
                      this.props.dispatch(
                          setCloudSchedulerFilterTeamDropdownValueChanged(true)
                      );
                      if(val.target.value.length === 0){
                        localStorage.removeItem('teams');
                        localStorage.removeItem('teams_text');
                        this.setState({filterLoad:(this.tradesLocalText || this.shiftsLocalText) ? true : false})
                      }
                      else {
                        this.setState({filterLoad:true});
                      }
                    }}
                    refDD={(ms: MultiSelectComponent) => (this.teamFMSCom = ms)}
                />
              </div>
              <div style={{margin: '10px'}}>
                <GlobalMultiSelection
                    floatLabelType='Always'
                    field={{text: 'trade_code', value: 'trade_id'}}
                    id='cloudscheduler-multiselection'
                    url={`trade/trade-codes-by-team?teamIds=${this.teamValues}`}
                    placeHolder='Select Trades'
                    value={this.tradeValues}
                    onChange={(val: any) => {
                      this.tradeValues = val.target.value
                      if(val.target.value.length === 0){
                        localStorage.removeItem('trades');
                        localStorage.removeItem('trades_text');
                        this.setState({filterLoad:(this.teamsLocalText || this.shiftsLocalText) ? true : false})
                      }
                      else {
                        this.setState({filterLoad:true});
                      }
                    }}
                    refDD={(ms: MultiSelectComponent) =>
                        (this.tradeFMSCom = ms)
                    }
                />
              </div>
              <div style={{margin: '10px'}}>
                <GlobalMultiSelection
                    floatLabelType='Always'
                    field={{text: 'rosterCode', value: 'rosterCode'}}
                    id='cloudscheduler-multiselection-shift'
                    url='shift'
                    placeHolder='Select Shift'
                    value={this.shiftValues}
                    onChange={(val: any) => {
                      this.shiftValues = val.target.value
                      if(val.target.value.length === 0){
                        localStorage.removeItem('shifts');
                        localStorage.removeItem('shifts_text');
                        this.setState({filterLoad:(this.tradesLocalText || this.teamsLocalText) ? true : false})

                      }
                      else {
                        this.setState({filterLoad:true});
                      }
                    }}
                    refDD={(ms: MultiSelectComponent) => (this.shiftFMSCom = ms)}
                />
              </div>
            </GlobalDialog>
        ) : null}
        <TabComponent
          ref={(tab) => (this.tabObj = tab)}
          selecting={this.begin.bind(this)}
          statelessTemplates={['directiveTemplates']}
        >
          <TabItemsDirective >
            <TabItemDirective
                header={this.headerText[0]}
                content={this.renderScheduledComponent}
            />
            <TabItemDirective
              header={this.headerText[1]}
              content={this.content1}
            />
            <TabItemDirective
              header={this.headerText[2]}
              content={this.content2}
            />
            <TabItemDirective
              header={this.headerText[3]}
              content={this.content3}
              disabled
            />
            <TabItemDirective
              header={this.headerText[4]}
              content={this.content4}
              disabled
            />
            <TabItemDirective
              header={{ text: 'Material' }}
              content={this.contentMaterial.bind(this)}
              disabled
            />
            <TabItemDirective
              header={{ text: 'Attachments' }}
              content={this.contentAttachment.bind(this)}
              disabled
            />
          </TabItemsDirective>
        </TabComponent>
      </div>
    );
  }
}

const mapStateToProps = (state: RootState) => ({
  searchCaseOperation: state.search.searchCaseOperation,
  searchCaseOrder: state.search.searchCaseOrder,
  searchCaseGantt: state.search.searchCaseGantt,
  isDataPulled: state.search.isDataPulled,
});

const mapDispatchToProps = (dispatch: any) => ({
  setCloudSchedularGantDataChanged,
  setIsDataPulled,
});

//export default connect(mapStateToProps, mapDispatchToProps)(SchedulerTabBar);


const ConnectedSchedulerTabBar = connect(
    mapStateToProps,
    mapDispatchToProps
)(SchedulerTabBar);

function withMyHook(Component: any) {
  return function WrappedComponent(props: any) {
    const dispatch = useDispatch();
    return <Component {...props} dispatch={dispatch}/>;
  };
}

export default withMyHook(ConnectedSchedulerTabBar);
